"use client";

import { useEffect, useRef, useState } from "react";

type DeferredTrustBadgeProps = {
  href: string;
  src: string;
  label: string;
  imageAlt: string;
  imageWidth: number;
  imageHeight: number;
  className?: string;
  referrerPolicy?: React.HTMLAttributeReferrerPolicy;
  imageCode?: string;
  rel?: string;
};

export function DeferredTrustBadge({
  href,
  src,
  label,
  imageAlt,
  imageWidth,
  imageHeight,
  className,
  referrerPolicy,
  imageCode,
  rel,
}: DeferredTrustBadgeProps) {
  const badgeRef = useRef<HTMLAnchorElement>(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const badge = badgeRef.current;
    if (!badge) return;
    if (!("IntersectionObserver" in window)) {
      setShouldLoad(true);
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry?.isIntersecting) return;
      setShouldLoad(true);
      observer.disconnect();
    }, { rootMargin: "0px 0px 240px 0px" });
    observer.observe(badge);
    return () => observer.disconnect();
  }, []);

  return (
    <a
      ref={badgeRef}
      className={className || "footer-enamad-seal"}
      href={href}
      target="_blank"
      rel={rel}
      referrerPolicy={referrerPolicy}
      aria-label={label}
    >
      {shouldLoad ? (
        <img
          src={src}
          alt={imageAlt}
          width={imageWidth}
          height={imageHeight}
          loading="lazy"
          decoding="async"
          referrerPolicy={referrerPolicy}
          {...(imageCode ? { code: imageCode } : {})}
        />
      ) : (
        <span className="footer-trust-placeholder" aria-hidden="true">{imageAlt}</span>
      )}
    </a>
  );
}
